import { Button } from '@components/button';
import { createForm } from '@components/form';
import { Modal, hideModal, useModal } from '@components/modal';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useAddAzureAdSettings } from 'api/company/hooks';
import { AzureADSettings } from 'api/company/requests';

export const useAzureADSettingsModal = () => useModal(AzureADSettingsForm);

const Form = createForm<AzureADSettings>();

const AzureADSettingsForm = () => {
  const { t } = useScopedTranslate(locale);
  const submitMutation = useAddAzureAdSettings();

  const submit = async (values: AzureADSettings) => {
    await submitMutation.mutateAsync(values);
    hideModal();
  };

  return (
    <Modal>
      <Modal.SimpleHeader title={t('title')} />
      <Modal.Content>
        <Stack space={6}>
          <Text color="textSecondary" text={t('description')} />
          <Form onSubmit={submit}>
            <Form.TextField id="tenantId" label={t('tenantId')} validators={['required']} />
            <Form.TextField id="clientId" label={t('clientId')} validators={['required']} />
            <Form.Actions>
              <Button
                text={t('core.cancel')}
                isDisabled={submitMutation.isLoading}
                onClick={hideModal}
                variant="secondary"
              />
              <Form.Submit
                text={t('enable')}
                variant="primary-blue"
                isDisabled={submitMutation.isLoading}
              />
            </Form.Actions>
          </Form>
        </Stack>
      </Modal.Content>
    </Modal>
  );
};

const locale = {
  en: {
    title: 'Enable Azure SSO',
    description:
      'Please enter the Tenant ID and Client ID from your Azure Enterprise applications page',
    tenantId: 'Tenant ID',
    clientId: 'Client ID',
    enable: 'Enable',
  },
};
